<uc-engage-card-cta
	ucImpression
	(onImpression)="onUniImpression($event)"
	(ctaClicked)="onUniClick()"
	[backgroundImage]="uni().profile?.cover_image ?? ''"
	icon="fire.svg"
	iconText="Recommended University"
	[hideIconOnMobile]="true"
	[cardTitle]="uni().name"
	[description]="description()"
	[link]="'/universities/' + uni().slug"
	[uniId]="uni().id"
	[enableSave]="true"
	[componentName]="componentName()"
	[isSaved]="uni().saved ? 1 : 0"
	[product]="product()"
	[ugSearchOrderPosition]="!isClearing() ? uni().order : null"
	[cleSearchOrderPosition]="isClearing() ? uni().order : null"
	[uniName]="uni().name"
>
	@if (uni().stats.recommended_percentage === 0) {
		<uc-write-review-btn
			leave-review
			[universityId]="uni().id"
			[universityName]="uni().name"
			[universityUrl]="uni().slug"
			buttonText="Leave a review"
			customStyles="text-base"
		/>
	}

	<div class="flex gap-3">
		@if (!isClearing()) {
			<uc-request-btn
				class="w-full sm:w-auto"
				[params]="uni().id"
				[componentName]="componentName()"
				[product]="product()"
				[ugSearchOrderPosition]="uni().order"
			/>
		}
		<uc-recommended-visit-website-btn
			class="w-full sm:w-auto"
			[uniId]="uni().id"
			[uniName]="uni().name"
			[externalUrl]="uni().profile?.external_url ?? ''"
			[searchOrderPosition]="uni().order"
			[componentName]="componentName()"
			[product]="product()"
			customStyles="!block !w-full sm:!w-auto"
			[privacyPolicyUrl]="uni().privacy_policy_url"
		/>
	</div>
</uc-engage-card-cta>
